import { PowerUpsService } from "../../../services/powerups/powerups.service";
const _powerupsService = new PowerUpsService();

const setSidebarFullAction = ({ commit }, payload: boolean): void => {
  commit("setSidebarFull", payload);
};

const setOpenChatAction = ({ commit }, payload: boolean): void => {
  commit("setOpenChat", payload);
};

const setOpenCall = ({ commit }, payload: boolean): void => {
  commit("setOpenCall", payload);
};

const setOpenOtherReasonAction = ({ commit }, payload: boolean): void => {
  commit("setOpenOtherReason", payload);
};
const setActiveMenuAction = ({ commit }, payload): void => {
  commit("setActiveMenu", payload);
};
const setPowerUpsNotificationsAction = ({ commit }, payload): void => {
  commit("setPowerUpsNotifications", payload);
};

const getPowerUpsNotificationsAction = (
  { commit },
  { userId, spaceId }
): void => {
  return;
  _powerupsService.getPowerUpsNotification(userId, spaceId).then((res) => {
    commit("setPowerUpsNotifications", res.data[0].notifications);
  });
};
export default {
  setSidebarFullAction,
  setOpenChatAction,
  setOpenCall,
  setOpenOtherReasonAction,
  setActiveMenuAction,
  setPowerUpsNotificationsAction,
  getPowerUpsNotificationsAction,
};
